export enum AmpouleEnum {
  AMPOULE_FLUOCOMPACTE = 'AMPOULE_FLUOCOMPACTE',
  AMPOULE_HALOGENE = 'AMPOULE_HALOGENE',
  AMPOULE_LED = 'AMPOULE_LED',
  AMPOULE_FLUORESCENT = 'AMPOULE_FLUORESCENT',
}
